module.exports = __webpack_public_path__ + "img/Workflows.9c3a1153.svg";